import * as systemTypes from "@/domains/profile/constants/system-types";
import * as customTypes from "@/domains/profile/constants/custom-types";

function numberFormatter(value) {
    console.log('number formatter', value, value.number)
    return { value: value.number };
}

function booleanFormatter(value) {
    return { value: !!value.number };
}

function dateFormatter(value) {
    return { value: value.date };
}

function listFormatter(value) {
    const { dictionaries } = value;
    const items = dictionaries.filter((item) => !item.custom);
    const customItems = dictionaries.filter((item) => item.custom);
    return {
        items: items.map((item) => item.id),
        customItems: customItems.map((item) => item.text),
    };
}

function filesFormatter(value) {
    return { files: [], oldFiles: value.files || [] };
}

function jsonFormatter(value) {
    return { value: value.json };
}

const systemFormatters = {
    [systemTypes.FIELD_TYPE_PHOTO]: filesFormatter,
    [systemTypes.FIELD_TYPE_GENDER]: numberFormatter,
    [systemTypes.FIELD_TYPE_BIRTHDAY]: dateFormatter,
    [systemTypes.FIELD_TYPE_CITIZENSHIP]: listFormatter,
    [systemTypes.FIELD_TYPE_WAY_TO_WORK]: listFormatter,
    [systemTypes.FIELD_TYPE_VACANCY_SOURCE]: listFormatter,
    [systemTypes.FIELD_TYPE_METRO]: listFormatter,
    [systemTypes.FIELD_TYPE_DESIRED_POSITION]: listFormatter,
    [systemTypes.FIELD_TYPE_COVID]: booleanFormatter,
    [systemTypes.FIELD_TYPE_TRAVELING_WORK]: booleanFormatter,
    [systemTypes.FIELD_TYPE_PHONE]: (value) => {
        if (!value.string) return "";
        const { string } = value;
        if (string.length > 0 && string[0] === "8") {
            return { value: `+7${string.slice(1)}` };
        }
        return { value: string };
    },
    [systemTypes.FIELD_TYPE_REGISTRATION_ADDRESS]: jsonFormatter,
    [systemTypes.FIELD_TYPE_PORTFOLIO]: (value) => {
        const { files, json } = value;
        return {
            files: [],
            oldFiles: files || [],
            value: json,
        };
    },
    [systemTypes.FIELD_TYPE_PASSPORT]: jsonFormatter,
    [systemTypes.FIELD_TYPE_DOCUMENTS]: jsonFormatter,
    [systemTypes.FIELD_TYPE_FRIENDS_IN_COMPANY]: jsonFormatter,
    [systemTypes.FIELD_TYPE_AUTO]: jsonFormatter,
    [systemTypes.FIELD_TYPE_EXPERIENCE]: jsonFormatter,
    [systemTypes.FIELD_TYPE_CAREER]: jsonFormatter,
    [systemTypes.FIELD_TYPE_ADDITIONAL_PHONE]: jsonFormatter,
    [systemTypes.FIELD_TYPE_SOCIALS]: jsonFormatter,
    [systemTypes.FIELD_TYPE_EDUCATION]: jsonFormatter,
    [systemTypes.FIELD_TYPE_SKILLS]: jsonFormatter,
    [systemTypes.FIELD_TYPE_PERSONAL_DATA]: jsonFormatter,
    [systemTypes.FIELD_TYPE_RECENT_JOBS]: jsonFormatter,
};

const customFormatters = {
    [customTypes.FIELD_TYPE_NUMBER]: numberFormatter,
    [customTypes.FIELD_TYPE_BOOLEAN]: booleanFormatter,
    [customTypes.FIELD_TYPE_DATE]: dateFormatter,
    [customTypes.FIELD_TYPE_PERIOD]: (value) => {
        const { date, period } = value;
        if (!date || !period) return { value: ["", ""] };

        return { value: [date, period] };
    },
    [customTypes.FIELD_TYPE_CHECKBOXES]: (value) => {
        const { dictionaries } = value;
        return { value: dictionaries.map((item) => item.id) };
    },
    [customTypes.FIELD_TYPE_RADIO]: (value) => {
        const { dictionaries } = value;
        const [item] = dictionaries;
        return { value: item ? [item.id] : [] };
    },
    [customTypes.FIELD_TYPE_LIST_SINGLE]: listFormatter,
    [customTypes.FIELD_TYPE_LIST_MULTIPLE]: listFormatter,
    [customTypes.FIELD_TYPE_FILE]: filesFormatter,
};

export function getFieldValue(field, value) {
    if (!value) return { value: null };

    const { isSystem, fieldType } = field;

    const formatter = isSystem ? systemFormatters[fieldType] : customFormatters[fieldType];
    if (typeof formatter === "function") return formatter(value);
    return { value: value.string };
}
